module.exports = new __parcel__URL__("jenkins.77ef5ed5.svg").toString();